var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "edit-mapping" },
    [
      _c(
        "b-modal",
        {
          ref: "mapEditModalRef",
          attrs: {
            title: _vm.modalTitle(),
            "hide-header-close": "",
            centered: ""
          },
          on: { hide: _vm.cancelUpdateMapping, shown: _vm.focusOnInput }
        },
        [
          _c("b-container", { attrs: { fluid: "" } }, [
            this.element.el_type === "Shape"
              ? _c(
                  "div",
                  [
                    _c(
                      "b-row",
                      { staticClass: "mb-3" },
                      [
                        _c(
                          "b-col",
                          { staticClass: "modal-label", attrs: { cols: "3" } },
                          [_vm._v(_vm._s(_vm.$t("TEMPLATE.KEY")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c("b-form-input", {
                              ref: "updateFieldKey",
                              attrs: { type: "text", placeholder: "Key" },
                              model: {
                                value: _vm.element.key,
                                callback: function($$v) {
                                  _vm.$set(_vm.element, "key", $$v)
                                },
                                expression: "element.key"
                              }
                            }),
                            _vm._v(" "),
                            _vm.element.key && !_vm.isKeyUnique
                              ? _c("div", { staticStyle: { color: "red" } }, [
                                  _vm._v("Key must be unique.")
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mb-3" },
                      [
                        _c(
                          "b-col",
                          { staticClass: "modal-label", attrs: { cols: "3" } },
                          [_vm._v(_vm._s(_vm.$t("TEMPLATE.DATA_TYPE")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c("b-form-select", {
                              attrs: {
                                plain: true,
                                options: _vm.listTypes,
                                placeholder: "Mapping Type"
                              },
                              on: {
                                input: function($event) {
                                  _vm.handleRequired()
                                }
                              },
                              model: {
                                value: _vm.element.type,
                                callback: function($$v) {
                                  _vm.$set(_vm.element, "type", $$v)
                                },
                                expression: "element.type"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.element.type == "date"
                      ? _c(
                          "b-row",
                          { staticClass: "mb-3" },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "modal-label",
                                attrs: { cols: "3" }
                              },
                              [_vm._v(_vm._s(_vm.$t("TEMPLATE.DATE_CATEGORY")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    plain: true,
                                    options: _vm.dateCategoryList,
                                    placeholder: "Select Date Category"
                                  },
                                  model: {
                                    value: _vm.element.date_category,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.element,
                                        "date_category",
                                        $$v
                                      )
                                    },
                                    expression: "element.date_category"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.element.type == "date"
                      ? _c(
                          "b-row",
                          { staticClass: "mb-3" },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "modal-label",
                                attrs: { cols: "3" }
                              },
                              [_vm._v(_vm._s(_vm.$t("TEMPLATE.DATE_FORMAT")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    plain: true,
                                    options: _vm.dateFormatList,
                                    placeholder: "Select Date Format"
                                  },
                                  model: {
                                    value: _vm.element.dateFormat,
                                    callback: function($$v) {
                                      _vm.$set(_vm.element, "dateFormat", $$v)
                                    },
                                    expression: "element.dateFormat"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mb-3" },
                      [
                        _c(
                          "b-col",
                          { staticClass: "modal-label", attrs: { cols: "3" } },
                          [_vm._v(_vm._s(_vm.$t("TEMPLATE.MAPPING_CATEGORY")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c("b-form-select", {
                              attrs: {
                                plain: true,
                                options: _vm.mappingCategories,
                                placeholder: "Mapping Category"
                              },
                              model: {
                                value: _vm.element.category,
                                callback: function($$v) {
                                  _vm.$set(_vm.element, "category", $$v)
                                },
                                expression: "element.category"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mb-3" },
                      [
                        _c(
                          "b-col",
                          { staticClass: "modal-label", attrs: { cols: "3" } },
                          [_vm._v(_vm._s(_vm.$t("TEMPLATE.ORDER_OF_OCCUR")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c("b-form-select", {
                              attrs: {
                                plain: true,
                                options: _vm.orderOptions,
                                placeholder: "Mapping Order"
                              },
                              model: {
                                value: _vm.element.order,
                                callback: function($$v) {
                                  _vm.$set(_vm.element, "order", $$v)
                                },
                                expression: "element.order"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.canExtract
                      ? _c(
                          "b-row",
                          { staticClass: "mb-3" },
                          [
                            _c("b-col", { attrs: { cols: "3" } }, [
                              _vm._v(_vm._s(_vm.$t("TEMPLATE.EXT")))
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c("b-form-radio-group", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-radio custom-control-inline"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.element.extract,
                                            expression: "element.extract"
                                          }
                                        ],
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          type: "radio",
                                          id: "extEditYes"
                                        },
                                        domProps: {
                                          value: true,
                                          checked: _vm._q(
                                            _vm.element.extract,
                                            true
                                          )
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.$set(
                                              _vm.element,
                                              "extract",
                                              true
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "custom-control-label",
                                          attrs: { for: "extEditYes" }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("COMMON.YES")))]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-radio custom-control-inline"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.element.extract,
                                            expression: "element.extract"
                                          }
                                        ],
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          type: "radio",
                                          id: "extEditNo"
                                        },
                                        domProps: {
                                          value: false,
                                          checked: _vm._q(
                                            _vm.element.extract,
                                            false
                                          )
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.$set(
                                              _vm.element,
                                              "extract",
                                              false
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "custom-control-label",
                                          attrs: { for: "extEditNo" }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("COMMON.NO")))]
                                      )
                                    ]
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mb-3" },
                      [
                        _c("b-col", { attrs: { cols: "3" } }, [
                          _vm._v(_vm._s(_vm.$t("TEMPLATE.EXT_BY_WORDS")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c("b-form-radio-group", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "custom-control custom-radio custom-control-inline"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.element.extract_by_words,
                                        expression: "element.extract_by_words"
                                      }
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      type: "radio",
                                      id: "extractByWordEditYes"
                                    },
                                    domProps: {
                                      value: true,
                                      checked: _vm._q(
                                        _vm.element.extract_by_words,
                                        true
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.$set(
                                          _vm.element,
                                          "extract_by_words",
                                          true
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: "extractByWordEditYes" }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("COMMON.YES")))]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "custom-control custom-radio custom-control-inline"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.element.extract_by_words,
                                        expression: "element.extract_by_words"
                                      }
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      type: "radio",
                                      id: "extractByWordEditNo"
                                    },
                                    domProps: {
                                      value: false,
                                      checked: _vm._q(
                                        _vm.element.extract_by_words,
                                        false
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.$set(
                                          _vm.element,
                                          "extract_by_words",
                                          false
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: "extractByWordEditNo" }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("COMMON.NO")))]
                                  )
                                ]
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mb-3" },
                      [
                        _c("b-col", { attrs: { cols: "3" } }, [
                          _vm._v(_vm._s(_vm.$t("TEMPLATE.REDACT_FIELD")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c("b-form-radio-group", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "custom-control custom-radio custom-control-inline"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.element.redact_field,
                                        expression: "element.redact_field"
                                      }
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      type: "radio",
                                      id: "redactFieldsYes"
                                    },
                                    domProps: {
                                      value: true,
                                      checked: _vm._q(
                                        _vm.element.redact_field,
                                        true
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.$set(
                                          _vm.element,
                                          "redact_field",
                                          true
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: "redactFieldsYes" }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("COMMON.YES")))]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "custom-control custom-radio custom-control-inline"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.element.redact_field,
                                        expression: "element.redact_field"
                                      }
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      type: "radio",
                                      id: "redactFieldsNo"
                                    },
                                    domProps: {
                                      value: false,
                                      checked: _vm._q(
                                        _vm.element.redact_field,
                                        false
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.$set(
                                          _vm.element,
                                          "redact_field",
                                          false
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: "redactFieldsNo" }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("COMMON.NO")))]
                                  )
                                ]
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mb-3" },
                      [
                        _c("b-col", { attrs: { cols: "3" } }, [
                          _vm._v(_vm._s(_vm.$t("TEMPLATE.SHOW_FIELD")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c("b-form-radio-group", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "custom-control custom-radio custom-control-inline"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.element.show_field,
                                        expression: "element.show_field"
                                      }
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      type: "radio",
                                      id: "showFieldTrue"
                                    },
                                    domProps: {
                                      value: true,
                                      checked: _vm._q(
                                        _vm.element.show_field,
                                        true
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.$set(
                                          _vm.element,
                                          "show_field",
                                          true
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: "showFieldTrue" }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("COMMON.YES")))]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "custom-control custom-radio custom-control-inline"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.element.show_field,
                                        expression: "element.show_field"
                                      }
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      type: "radio",
                                      id: "showFieldFalse"
                                    },
                                    domProps: {
                                      value: false,
                                      checked: _vm._q(
                                        _vm.element.show_field,
                                        false
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.$set(
                                          _vm.element,
                                          "show_field",
                                          false
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: "showFieldFalse" }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("COMMON.NO")))]
                                  )
                                ]
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mb-3" },
                      [
                        _c(
                          "b-col",
                          { staticClass: "modal-label", attrs: { cols: "3" } },
                          [_vm._v(_vm._s(_vm.$t("TEMPLATE.CASE")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c("b-form-select", {
                              attrs: {
                                plain: true,
                                options: _vm.caseCategories,
                                placeholder: "Mapping Case"
                              },
                              model: {
                                value: _vm.element.case,
                                callback: function($$v) {
                                  _vm.$set(_vm.element, "case", $$v)
                                },
                                expression: "element.case"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mb-3" },
                      [
                        _c("b-col", { attrs: { cols: "3" } }, [
                          _vm._v(_vm._s(_vm.$t("TEMPLATE.SENS_DATA")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c("b-form-radio-group", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "custom-control custom-radio custom-control-inline"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.element.sensitive_data,
                                        expression: "element.sensitive_data"
                                      }
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      type: "radio",
                                      id: "editSensitiveDataYes"
                                    },
                                    domProps: {
                                      value: true,
                                      checked: _vm._q(
                                        _vm.element.sensitive_data,
                                        true
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.$set(
                                          _vm.element,
                                          "sensitive_data",
                                          true
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: "editSensitiveDataYes" }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("COMMON.YES")))]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "custom-control custom-radio custom-control-inline"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.element.sensitive_data,
                                        expression: "element.sensitive_data"
                                      }
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      type: "radio",
                                      id: "editSensitiveDataNo"
                                    },
                                    domProps: {
                                      value: false,
                                      checked: _vm._q(
                                        _vm.element.sensitive_data,
                                        false
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.$set(
                                          _vm.element,
                                          "sensitive_data",
                                          false
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: "editSensitiveDataNo" }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("COMMON.NO")))]
                                  )
                                ]
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.canShowRequired
                      ? _c(
                          "b-row",
                          { staticClass: "mb-3" },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "modal-label",
                                attrs: { cols: "3" }
                              },
                              [_vm._v(_vm._s(_vm.$t("TEMPLATE.REQ")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c("b-form-radio-group", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-radio custom-control-inline"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.element.required,
                                            expression: "element.required"
                                          }
                                        ],
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          type: "radio",
                                          id: "requiredEditYes"
                                        },
                                        domProps: {
                                          value: true,
                                          checked: _vm._q(
                                            _vm.element.required,
                                            true
                                          )
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.$set(
                                              _vm.element,
                                              "required",
                                              true
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "custom-control-label",
                                          attrs: { for: "requiredEditYes" }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("COMMON.YES")))]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-radio custom-control-inline"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.element.required,
                                            expression: "element.required"
                                          }
                                        ],
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          type: "radio",
                                          id: "requiredEditNo"
                                        },
                                        domProps: {
                                          value: false,
                                          checked: _vm._q(
                                            _vm.element.required,
                                            false
                                          )
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.$set(
                                              _vm.element,
                                              "required",
                                              false
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "custom-control-label",
                                          attrs: { for: "requiredEditNo" }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("COMMON.NO")))]
                                      )
                                    ]
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mb-3" },
                      [
                        _c(
                          "b-col",
                          { staticClass: "modal-label", attrs: { cols: "3" } },
                          [_vm._v(_vm._s(_vm.$t("TEMPLATE.ALIAS")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c("multiselect", {
                              attrs: {
                                "tag-placeholder": "Add this as Alias",
                                placeholder: "Search or add a tag",
                                options: _vm.aliasOptions,
                                multiple: true,
                                taggable: true
                              },
                              on: { tag: _vm.addTag },
                              model: {
                                value: _vm.selectedAliasData,
                                callback: function($$v) {
                                  _vm.selectedAliasData = $$v
                                },
                                expression: "selectedAliasData"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { staticClass: "modal-label", attrs: { cols: "3" } },
                          [_vm._v(_vm._s(_vm.$t("COMMON.DESCRIPTION")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c("b-form-textarea", {
                              attrs: {
                                placeholder: _vm.$t("COMMON.DESCRIPTION")
                              },
                              model: {
                                value: _vm.element.description,
                                callback: function($$v) {
                                  _vm.$set(_vm.element, "description", $$v)
                                },
                                expression: "element.description"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm.element.type !== "npi"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-row",
                        { staticClass: "mb-3" },
                        [
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _vm._v(_vm._s(_vm.$t("COMMON.NAME")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-form-input", {
                                ref: "updateFieldKey",
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$t("TEMPLATE.GRP_NAME")
                                },
                                model: {
                                  value: _vm.element.key,
                                  callback: function($$v) {
                                    _vm.$set(_vm.element, "key", $$v)
                                  },
                                  expression: "element.key"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.element.key && !_vm.isKeyUnique
                            ? _c("div", { staticStyle: { color: "red" } }, [
                                _vm._v("Key must be unique.")
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mb-3" },
                        [
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _vm._v(_vm._s(_vm.$t("TEMPLATE.TYPE")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-form-select", {
                                attrs: {
                                  plain: true,
                                  options: _vm.groupTypes,
                                  placeholder: _vm.$t("TEMPLATE.GRP_TYPE")
                                },
                                on: {
                                  input: function($event) {
                                    _vm.handleRequired()
                                  }
                                },
                                model: {
                                  value: _vm.element.type,
                                  callback: function($$v) {
                                    _vm.$set(_vm.element, "type", $$v)
                                  },
                                  expression: "element.type"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mb-3" },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "modal-label",
                              attrs: { cols: "3" }
                            },
                            [_vm._v(_vm._s(_vm.$t("TEMPLATE.ORDER_OF_OCCUR")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-form-select", {
                                attrs: {
                                  plain: true,
                                  options: _vm.orderOptions,
                                  placeholder: "Mapping Order"
                                },
                                model: {
                                  value: _vm.element.order,
                                  callback: function($$v) {
                                    _vm.$set(_vm.element, "order", $$v)
                                  },
                                  expression: "element.order"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.canShowRequired
                        ? _c(
                            "b-row",
                            { staticClass: "mb-3" },
                            [
                              _c("b-col", { attrs: { cols: "3" } }, [
                                _vm._v(_vm._s(_vm.$t("TEMPLATE.REQ")))
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c("b-form-radio-group", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-radio custom-control-inline"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.element.required,
                                              expression: "element.required"
                                            }
                                          ],
                                          staticClass: "custom-control-input",
                                          attrs: {
                                            type: "radio",
                                            id: "requiredGrpEditYes"
                                          },
                                          domProps: {
                                            value: true,
                                            checked: _vm._q(
                                              _vm.element.required,
                                              true
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.$set(
                                                _vm.element,
                                                "required",
                                                true
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "custom-control-label",
                                            attrs: { for: "requiredGrpEditYes" }
                                          },
                                          [_vm._v(_vm._s(_vm.$t("COMMON.YES")))]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-radio custom-control-inline"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.element.required,
                                              expression: "element.required"
                                            }
                                          ],
                                          staticClass: "custom-control-input",
                                          attrs: {
                                            type: "radio",
                                            id: "requiredGrpEditNo"
                                          },
                                          domProps: {
                                            value: false,
                                            checked: _vm._q(
                                              _vm.element.required,
                                              false
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.$set(
                                                _vm.element,
                                                "required",
                                                false
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "custom-control-label",
                                            attrs: { for: "requiredGrpEditNo" }
                                          },
                                          [_vm._v(_vm._s(_vm.$t("COMMON.NO")))]
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c(
                        "b-row",
                        { staticClass: "mb-3" },
                        [
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _vm._v("Name")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-form-input", {
                                ref: "updateFieldKey",
                                attrs: {
                                  type: "text",
                                  placeholder: "Group Name"
                                },
                                model: {
                                  value: _vm.element.key,
                                  callback: function($$v) {
                                    _vm.$set(_vm.element, "key", $$v)
                                  },
                                  expression: "element.key"
                                }
                              }),
                              _vm._v(" "),
                              _vm.element.key && !_vm.isKeyUnique
                                ? _c("div", { staticStyle: { color: "red" } }, [
                                    _vm._v("Key must be unique.")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mb-3" },
                        [
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _vm._v("NPI")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-form-select", {
                                attrs: {
                                  plain: true,
                                  options: _vm.npiFields,
                                  placeholder: "NPI",
                                  state: !_vm.$v.group.npi.$invalid
                                },
                                on: {
                                  change: function($event) {
                                    _vm.npiFieldChanged("npi")
                                  }
                                },
                                model: {
                                  value: _vm.group.npi,
                                  callback: function($$v) {
                                    _vm.$set(_vm.group, "npi", $$v)
                                  },
                                  expression: "group.npi"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "b-form-invalid-feedback",
                                { attrs: { id: "input2LiveFeedback" } },
                                [
                                  _vm._v(
                                    "This is a required field\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mb-3" },
                        [
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _vm._v("Prescriber First Name")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-form-select", {
                                attrs: {
                                  plain: true,
                                  options: _vm.npiFields,
                                  placeholder: "First Name"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.npiFieldChanged("first_name")
                                  }
                                },
                                model: {
                                  value: _vm.group.first_name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.group, "first_name", $$v)
                                  },
                                  expression: "group.first_name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mb-3" },
                        [
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _vm._v("Prescriber Last Name")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-form-select", {
                                attrs: {
                                  plain: true,
                                  options: _vm.npiFields,
                                  placeholder: "Last Name"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.npiFieldChanged("last_name")
                                  }
                                },
                                model: {
                                  value: _vm.group.last_name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.group, "last_name", $$v)
                                  },
                                  expression: "group.last_name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mb-3" },
                        [
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _vm._v("Prescriber Name")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-form-select", {
                                attrs: {
                                  plain: true,
                                  options: _vm.npiFields,
                                  placeholder: "Name"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.npiFieldChanged("name")
                                  }
                                },
                                model: {
                                  value: _vm.group.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.group, "name", $$v)
                                  },
                                  expression: "group.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mb-3" },
                        [
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _vm._v("City")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-form-select", {
                                attrs: {
                                  plain: true,
                                  options: _vm.npiFields,
                                  placeholder: "City"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.npiFieldChanged("city")
                                  }
                                },
                                model: {
                                  value: _vm.group.city,
                                  callback: function($$v) {
                                    _vm.$set(_vm.group, "city", $$v)
                                  },
                                  expression: "group.city"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mb-3" },
                        [
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _vm._v("State")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-form-select", {
                                attrs: {
                                  plain: true,
                                  options: _vm.npiFields,
                                  placeholder: "State"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.npiFieldChanged("state")
                                  }
                                },
                                model: {
                                  value: _vm.group.state,
                                  callback: function($$v) {
                                    _vm.$set(_vm.group, "state", $$v)
                                  },
                                  expression: "group.state"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mb-3" },
                        [
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _vm._v("Zipcode")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-form-select", {
                                attrs: {
                                  plain: true,
                                  options: _vm.npiFields,
                                  placeholder: "ZipCode"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.npiFieldChanged("zipcode")
                                  }
                                },
                                model: {
                                  value: _vm.group.zipcode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.group, "zipcode", $$v)
                                  },
                                  expression: "group.zipcode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "w-100 d-flex justify-content-end",
              attrs: { slot: "modal-footer" },
              slot: "modal-footer"
            },
            [
              _c(
                "b-btn",
                {
                  staticClass: "float-right",
                  attrs: {
                    size: "sm",
                    variant: "secondary mr-1",
                    disabled:
                      !_vm.isKeyUnique ||
                      (_vm.element.type == "date" && !_vm.element.dateFormat)
                  },
                  on: { click: _vm.updateMapping }
                },
                [_vm._v(_vm._s(_vm.$t("COMMON.UPDATE")))]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  staticClass: "float-right",
                  attrs: { size: "sm", variant: "light" },
                  on: { click: _vm.cancelMapping }
                },
                [_vm._v(_vm._s(_vm.$t("COMMON.CANCEL")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "agnetEditMappingModal",
          attrs: {
            title: "Edit Mapping",
            "hide-header-close": "",
            centered: "",
            "ok-only": "",
            "ok-variant": "secondary"
          },
          on: { ok: _vm.editDrawing }
        },
        [
          _c("p", [
            _vm._v(
              "You are not permitted to access this. Kindly contact administrator"
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50e8caa4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50e8caa4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/editMapping.vue
// module id = 1133
// module chunks = 2